import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "limit-popover"
};
const _hoisted_2 = {
    key: 0,
    class: "limit-table"
};
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("colgroup", null, [
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-value" }),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-value" }),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-value" }),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-value" })
], -1 /* HOISTED */);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { colspan: "4" }, [
            /*#__PURE__*/ _createElementVNode("svg", {
                width: "200",
                height: "17"
            }, [
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "0,7 5,0 25,0 25,17 23,17 23,13 5,13",
                    class: "critical"
                }),
                /*#__PURE__*/ _createTextVNode(),
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "26,0 75,0 75,17 73,17 73,13 26,13",
                    class: "warning"
                }),
                /*#__PURE__*/ _createTextVNode(),
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "76,0 124,0 124,13 76,13",
                    class: "healthy"
                }),
                /*#__PURE__*/ _createTextVNode(),
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "125,0 174,0 174,13 127,13 127,17 125,17",
                    class: "warning"
                }),
                /*#__PURE__*/ _createTextVNode(),
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "175,0 195,0 200,7 195,13 177,13 177,17 175,17",
                    class: "critical"
                })
            ])
        ])
    ])
], -1 /* HOISTED */);
const _hoisted_5 = { class: "limit-value" };
const _hoisted_6 = { class: "limit-value" };
const _hoisted_7 = { class: "limit-value" };
const _hoisted_8 = { class: "limit-value" };
const _hoisted_9 = {
    key: 1,
    class: "limit-table"
};
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("colgroup", null, [
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-value" }),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-value" }),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-spacer" })
], -1 /* HOISTED */);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { colspan: "3" }, [
            /*#__PURE__*/ _createElementVNode("svg", {
                width: "130",
                height: "17"
            }, [
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "0,7 5,0 25,0 25,17 23,17 23,13 5,13",
                    class: "critical"
                }),
                /*#__PURE__*/ _createTextVNode(),
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "26,0 75,0 75,17 73,17 73,13 26,13",
                    class: "warning"
                }),
                /*#__PURE__*/ _createTextVNode(),
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "76,0 125,0 130,7 125,13 76,13",
                    class: "healthy"
                })
            ])
        ])
    ])
], -1 /* HOISTED */);
const _hoisted_12 = { class: "limit-value" };
const _hoisted_13 = { class: "limit-value" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("td", { class: "limit-spacer" }, null, -1 /* HOISTED */);
const _hoisted_15 = {
    key: 2,
    class: "limit-table"
};
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("colgroup", null, [
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-spacer" }),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-value" }),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-value" })
], -1 /* HOISTED */);
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { colspan: "3" }, [
            /*#__PURE__*/ _createElementVNode("svg", {
                width: "130",
                height: "17"
            }, [
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "0,7 5,0 54,0 54,13 5,13",
                    class: "healthy"
                }),
                /*#__PURE__*/ _createTextVNode(),
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "55,0 104,0 104,13 57,13 57,17 55,17",
                    class: "warning"
                }),
                /*#__PURE__*/ _createTextVNode(),
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "105,0 125,0 130,7 125,13 107,13 107,17 105,17",
                    class: "critical"
                })
            ])
        ])
    ])
], -1 /* HOISTED */);
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("td", { class: "limit-spacer" }, null, -1 /* HOISTED */);
const _hoisted_19 = { class: "limit-value" };
const _hoisted_20 = { class: "limit-value" };
const _hoisted_21 = {
    key: 3,
    class: "limit-table"
};
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("colgroup", null, [
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-value" }),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-spacer" })
], -1 /* HOISTED */);
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { colspan: "2" }, [
            /*#__PURE__*/ _createElementVNode("svg", {
                width: "80",
                height: "17"
            }, [
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "0,7 5,0 54,0 54,13 5,13",
                    class: "warning"
                }),
                /*#__PURE__*/ _createTextVNode(),
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "55,0 75,0 80,7 75,13 57,13 57,17 55,17",
                    class: "healthy"
                })
            ])
        ])
    ])
], -1 /* HOISTED */);
const _hoisted_24 = { class: "limit-value" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("td", { class: "limit-spacer" }, null, -1 /* HOISTED */);
const _hoisted_26 = {
    key: 4,
    class: "limit-table"
};
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("colgroup", null, [
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-value" }),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-spacer" })
], -1 /* HOISTED */);
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { colspan: "2" }, [
            /*#__PURE__*/ _createElementVNode("svg", {
                width: "80",
                height: "17"
            }, [
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "0,7 5,0 54,0 54,13 5,13",
                    class: "critical"
                }),
                /*#__PURE__*/ _createTextVNode(),
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "55,0 75,0 80,7 75,13 57,13 57,17 55,17",
                    class: "healthy"
                })
            ])
        ])
    ])
], -1 /* HOISTED */);
const _hoisted_29 = { class: "limit-value" };
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("td", { class: "limit-spacer" }, null, -1 /* HOISTED */);
const _hoisted_31 = {
    key: 5,
    class: "limit-table"
};
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("colgroup", null, [
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-spacer" }),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-value" })
], -1 /* HOISTED */);
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { colspan: "2" }, [
            /*#__PURE__*/ _createElementVNode("svg", {
                width: "80",
                height: "17"
            }, [
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "0,7 5,0 54,0 54,13 5,13",
                    class: "healthy"
                }),
                /*#__PURE__*/ _createTextVNode(),
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "55,0 75,0 80,7 75,13 57,13 57,17 55,17",
                    class: "warning"
                })
            ])
        ])
    ])
], -1 /* HOISTED */);
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("td", { class: "limit-spacer" }, null, -1 /* HOISTED */);
const _hoisted_35 = { class: "limit-value" };
const _hoisted_36 = {
    key: 6,
    class: "limit-table"
};
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("colgroup", null, [
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-spacer" }),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-value" })
], -1 /* HOISTED */);
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { colspan: "2" }, [
            /*#__PURE__*/ _createElementVNode("svg", {
                width: "80",
                height: "17"
            }, [
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "0,7 5,0 54,0 54,13 5,13",
                    class: "healthy"
                }),
                /*#__PURE__*/ _createTextVNode(),
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "55,0 75,0 80,7 75,13 57,13 57,17 55,17",
                    class: "critical"
                })
            ])
        ])
    ])
], -1 /* HOISTED */);
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("td", { class: "limit-spacer" }, null, -1 /* HOISTED */);
const _hoisted_40 = { class: "limit-value" };
const _hoisted_41 = {
    key: 7,
    class: "limit-table"
};
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("colgroup", null, [
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-spacer" }),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-value" }),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-value" })
], -1 /* HOISTED */);
const _hoisted_43 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { colspan: "3" }, [
            /*#__PURE__*/ _createElementVNode("svg", {
                width: "130",
                height: "17"
            }, [
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "0,7 5,0 54,0 54,13 5,13",
                    class: "healthy"
                }),
                /*#__PURE__*/ _createTextVNode(),
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "55,0 104,0 104,13 57,13 57,17 55,17",
                    class: "warning"
                }),
                /*#__PURE__*/ _createTextVNode(),
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "105,0 125,0 130,7 125,13 107,13 107,17 105,17",
                    class: "critical"
                })
            ])
        ])
    ])
], -1 /* HOISTED */);
const _hoisted_44 = /*#__PURE__*/ _createElementVNode("td", { class: "limit-spacer" }, null, -1 /* HOISTED */);
const _hoisted_45 = { class: "limit-value" };
const _hoisted_46 = { class: "limit-value" };
const _hoisted_47 = {
    key: 8,
    class: "limit-table"
};
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("colgroup", null, [
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-value" }),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("col", { class: "limit-value" })
], -1 /* HOISTED */);
const _hoisted_49 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { colspan: "2" }, [
            /*#__PURE__*/ _createElementVNode("svg", {
                width: "130",
                height: "17"
            }, [
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "0,7 5,0 30,0 30,13 5,13",
                    class: "critical"
                }),
                /*#__PURE__*/ _createTextVNode(),
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "31,0 95,0 95,13 33,13 33,17 31,17",
                    class: "healthy"
                }),
                /*#__PURE__*/ _createTextVNode(),
                /*#__PURE__*/ _createElementVNode("polygon", {
                    points: "96,0 126,0 130,7 125,13 98,13 98,17 96,17",
                    class: "critical"
                })
            ])
        ])
    ])
], -1 /* HOISTED */);
const _hoisted_50 = { class: "limit-value" };
const _hoisted_51 = { class: "limit-value" };
const _hoisted_52 = {
    key: 9,
    class: "clearfix text-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_popover = _resolveComponent("b-popover");
    return (_ctx.canShow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_b_popover, {
                target: _ctx.target,
                triggers: "hover",
                "custom-class": `limit`,
                placement: "auto"
            }, {
                title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.measurementName), 1 /* TEXT */)
                ]),
                default: _withCtx(() => [
                    _createTextVNode(),
                    (_ctx.layoutType == _ctx.limitLayoutEnum.All)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
                            _hoisted_3,
                            _createTextVNode(),
                            _hoisted_4,
                            _createTextVNode(),
                            _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.getValue(_ctx.limit.lowerCriticalLimit)), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.getValue(_ctx.limit.lowerWarningLimit)), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.getValue(_ctx.limit.upperWarningLimit)), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.getValue(_ctx.limit.upperCriticalLimit)), 1 /* TEXT */)
                                ])
                            ])
                        ]))
                        : (_ctx.layoutType == _ctx.limitLayoutEnum.LowerWarningCritical)
                            ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
                                _hoisted_10,
                                _createTextVNode(),
                                _hoisted_11,
                                _createTextVNode(),
                                _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.getValue(_ctx.limit.lowerCriticalLimit)), 1 /* TEXT */),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.getValue(_ctx.limit.lowerWarningLimit)), 1 /* TEXT */),
                                        _createTextVNode(),
                                        _hoisted_14
                                    ])
                                ])
                            ]))
                            : (_ctx.layoutType == _ctx.limitLayoutEnum.UpperWarningCritical)
                                ? (_openBlock(), _createElementBlock("table", _hoisted_15, [
                                    _hoisted_16,
                                    _createTextVNode(),
                                    _hoisted_17,
                                    _createTextVNode(),
                                    _createElementVNode("tbody", null, [
                                        _createElementVNode("tr", null, [
                                            _hoisted_18,
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.getValue(_ctx.limit.upperWarningLimit)), 1 /* TEXT */),
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.getValue(_ctx.limit.upperCriticalLimit)), 1 /* TEXT */)
                                        ])
                                    ])
                                ]))
                                : (_ctx.layoutType == _ctx.limitLayoutEnum.LowerWarningOnly)
                                    ? (_openBlock(), _createElementBlock("table", _hoisted_21, [
                                        _hoisted_22,
                                        _createTextVNode(),
                                        _hoisted_23,
                                        _createTextVNode(),
                                        _createElementVNode("tbody", null, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.getValue(_ctx.limit.lowerWarningLimit)), 1 /* TEXT */),
                                                _createTextVNode(),
                                                _hoisted_25
                                            ])
                                        ])
                                    ]))
                                    : (_ctx.layoutType == _ctx.limitLayoutEnum.LowerCriticalOnly)
                                        ? (_openBlock(), _createElementBlock("table", _hoisted_26, [
                                            _hoisted_27,
                                            _createTextVNode(),
                                            _hoisted_28,
                                            _createTextVNode(),
                                            _createElementVNode("tbody", null, [
                                                _createElementVNode("tr", null, [
                                                    _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.getValue(_ctx.limit.lowerCriticalLimit)), 1 /* TEXT */),
                                                    _createTextVNode(),
                                                    _hoisted_30
                                                ])
                                            ])
                                        ]))
                                        : (_ctx.layoutType == _ctx.limitLayoutEnum.UpperWarningOnly)
                                            ? (_openBlock(), _createElementBlock("table", _hoisted_31, [
                                                _hoisted_32,
                                                _createTextVNode(),
                                                _hoisted_33,
                                                _createTextVNode(),
                                                _createElementVNode("tbody", null, [
                                                    _createElementVNode("tr", null, [
                                                        _hoisted_34,
                                                        _createTextVNode(),
                                                        _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.getValue(_ctx.limit.upperWarningLimit)), 1 /* TEXT */)
                                                    ])
                                                ])
                                            ]))
                                            : (_ctx.layoutType == _ctx.limitLayoutEnum.UpperCriticalOnly)
                                                ? (_openBlock(), _createElementBlock("table", _hoisted_36, [
                                                    _hoisted_37,
                                                    _createTextVNode(),
                                                    _hoisted_38,
                                                    _createTextVNode(),
                                                    _createElementVNode("tbody", null, [
                                                        _createElementVNode("tr", null, [
                                                            _hoisted_39,
                                                            _createTextVNode(),
                                                            _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.getValue(_ctx.limit.upperCriticalLimit)), 1 /* TEXT */)
                                                        ])
                                                    ])
                                                ]))
                                                : (_ctx.layoutType == _ctx.limitLayoutEnum.UpperWarningCritical)
                                                    ? (_openBlock(), _createElementBlock("table", _hoisted_41, [
                                                        _hoisted_42,
                                                        _createTextVNode(),
                                                        _hoisted_43,
                                                        _createTextVNode(),
                                                        _createElementVNode("tbody", null, [
                                                            _createElementVNode("tr", null, [
                                                                _hoisted_44,
                                                                _createTextVNode(),
                                                                _createElementVNode("td", _hoisted_45, _toDisplayString(_ctx.getValue(_ctx.limit.upperWarningLimit)), 1 /* TEXT */),
                                                                _createTextVNode(),
                                                                _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.getValue(_ctx.limit.upperCriticalLimit)), 1 /* TEXT */)
                                                            ])
                                                        ])
                                                    ]))
                                                    : (_ctx.layoutType == _ctx.limitLayoutEnum.UpperLowerCritical)
                                                        ? (_openBlock(), _createElementBlock("table", _hoisted_47, [
                                                            _hoisted_48,
                                                            _createTextVNode(),
                                                            _hoisted_49,
                                                            _createTextVNode(),
                                                            _createElementVNode("tbody", null, [
                                                                _createElementVNode("tr", null, [
                                                                    _createElementVNode("td", _hoisted_50, _toDisplayString(_ctx.getValue(_ctx.limit.lowerCriticalLimit)), 1 /* TEXT */),
                                                                    _createTextVNode(),
                                                                    _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.getValue(_ctx.limit.upperCriticalLimit)), 1 /* TEXT */)
                                                                ])
                                                            ])
                                                        ]))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_52, "\r\n\t\t\t\t\tThis limit layout is not yet supported.\r\n\t\t\t\t"))
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["target"])
        ]))
        : _createCommentVNode("v-if", true);
}
